var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 7.5H5.0625C3.51094 7.5 2.25 8.76094 2.25 10.3125V18.1875C2.25 19.7391 3.51094 21 5.0625 21H18.9375C20.4891 21 21.75 19.7391 21.75 18.1875V10.3125C21.75 8.76094 20.4891 7.5 18.9375 7.5Z",
    fill: "#CBCBDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0734 3.04685L5.0625 5.19841C4.21875 5.38591 3 6.23435 3 7.2656C3 7.2656 3.70312 6.37498 5.29688 6.37498H18.75V5.41404C18.75 4.82341 18.5156 4.06873 18.0984 3.65154C17.5688 3.12185 16.8094 2.89216 16.0734 3.04685V3.04685Z",
    fill: "#CBCBDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGrey);
export default __webpack_public_path__ + "static/media/wallet-grey.21544144a6ac5b5536b6de5169b9a20f.svg";
export { ForwardRef as ReactComponent };